<template>
    <card-wrapper :title="title" :subtitle="subtitle">
        <div class="col-12">
            <flash-messages :hideErrors="hideMsg"></flash-messages>
        </div>
        <card-layout>
            <div class="row px-0 mx-0">
                <div class="col-12 col-md-3 h-100 px-0">
                    <settings-tabs :tab="tabName"></settings-tabs>
                </div>
                <div class="col-12 col-md-9 mh-100 px-0 tab-contents">
                    <div :class="{'px-3 py-3': !hasNoPaddings}"  id="v-pills-tabContent">
                        <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel"
                             aria-labelledby="v-pills-home-tab">
                            <slot />
                        </div>
                        <slot name="pagination"/>
                    </div>
                </div>
            </div>
        </card-layout>
    </card-wrapper>
</template>

<script>
import CardWrapper from '@/Shared/CardWrapper';
import CardLayout from "@/Shared/CardLayout";
import SettingsTabs from "@/Shared/SettingsTabs";
import FlashMessages from "@/Shared/FlashMessages";

export default {
    props: {
        title: {
            type: String,
            default: null
        },
        subtitle: {
            type: String,
            default: null
        },
        hideMsg: {
            type: Boolean,
            default: false
        },
        tabName: {
            type: String,
            required: true,
        },
        hasNoPaddings: Boolean,
    },
    components: {
        CardWrapper,
        CardLayout,
        SettingsTabs,
        FlashMessages
    },
}
</script>
